export default __webpack_public_path__ + "static/media/profile.e73b3e9b.png";